// Mock data for Armed Guard Officer Landing Page

export const siteConfig = {
  companyName: "Armed Guard Officers",
  tagline: "Licensed & Professional Armed Security in Florida",
  phone: "888-356-0005",
  email: "info@armedguardofficers.com",
  address: "12750 NW 17 St Suite 207 Miami, 33182"
};

export const heroData = {
  headline: "Licensed & Professional Armed Security Guards in Florida",
  subheadline: "Trusted protection for businesses, events, and communities. Fully licensed, insured, and background-checked armed officers ready to secure what matters most.",
  primaryCta: "Get a Free Security Consultation",
  secondaryCta: "Apply as an Armed Guard"
};

export const trustSignals = [
  {
    id: 1,
    title: "Florida Licensed",
    description: "All officers hold valid Florida Class G armed security licenses"
  },
  {
    id: 2,
    title: "Fully Insured",
    description: "Comprehensive liability coverage for complete peace of mind"
  },
  {
    id: 3,
    title: "Background Checked",
    description: "Rigorous screening and verification for every officer"
  },
  {
    id: 4,
    title: "Professionally Trained",
    description: "Ongoing training in firearms, de-escalation, and emergency response"
  }
];

export const services = [
  {
    id: 1,
    title: "Commercial Properties",
    description: "Protect your business assets, employees, and customers with armed security presence.",
    benefits: [
      "24/7 armed patrol services",
      "Access control management",
      "Incident reporting & documentation",
      "Visible deterrent to criminal activity"
    ]
  },
  {
    id: 2,
    title: "Residential Communities",
    description: "Secure gated communities, HOAs, and residential complexes with trained armed guards.",
    benefits: [
      "Gate & entry point security",
      "Community patrol services",
      "Emergency response coordination",
      "Resident safety monitoring"
    ]
  },
  {
    id: 3,
    title: "Events & Venues",
    description: "Professional armed security for concerts, corporate events, and private gatherings.",
    benefits: [
      "Crowd management & control",
      "VIP area protection",
      "Perimeter security",
      "Rapid incident response"
    ]
  },
  {
    id: 4,
    title: "VIP & Executive Protection",
    description: "Discreet, professional protection for executives, celebrities, and high-profile individuals.",
    benefits: [
      "Personal protection details",
      "Secure transportation",
      "Advance threat assessment",
      "24/7 close protection"
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Florida-Based Operations",
    description: "Locally owned and operated with deep knowledge of Florida security regulations and requirements."
  },
  {
    id: 2,
    title: "Rapid Deployment",
    description: "Quick response times with officers available for immediate deployment across the state."
  },
  {
    id: 3,
    title: "Trained Armed Officers",
    description: "Every officer undergoes extensive firearms training and regular certification renewals."
  },
  {
    id: 4,
    title: "Local Expertise",
    description: "We understand Florida's unique security challenges and tailor solutions accordingly."
  }
];

export const recruitmentData = {
  headline: "Join Our Team of Armed Security Professionals",
  description: "Are you a licensed armed security guard looking for a rewarding career in Florida? We're hiring experienced professionals who are committed to excellence.",
  benefits: [
    "Competitive pay rates",
    "Flexible scheduling options",
    "Career advancement opportunities",
    "Ongoing training & certification support",
    "Health & benefits packages",
    "Work across diverse assignments"
  ],
  cta: "Apply Now"
};

export const locationsServed = [
  "Miami",
  "Orlando",
  "Tampa",
  "Jacksonville",
  "Fort Lauderdale",
  "West Palm Beach",
  "St. Petersburg",
  "Hialeah",
  "Tallahassee",
  "Fort Myers",
  "Cape Coral",
  "Pembroke Pines"
];

export const testimonials = [
  {
    id: 1,
    name: "Michael R.",
    role: "Property Manager",
    company: "Sunrise Commercial Plaza",
    content: "Their armed guards have been protecting our commercial complex for over two years. Professional, punctual, and our tenants feel much safer.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah T.",
    role: "Event Coordinator",
    company: "Premier Events FL",
    content: "We've used their services for multiple high-profile events. The officers are discreet yet effective. Highly recommend for any large gathering.",
    rating: 5
  },
  {
    id: 3,
    name: "James K.",
    role: "HOA President",
    company: "Palm Grove Estates",
    content: "Since hiring Armed Guard Officer, incidents in our community have dropped significantly. Their professionalism is unmatched.",
    rating: 5
  }
];

export const footerData = {
  disclaimer: "Armed Guard Officers operates in full compliance with Florida Department of Agriculture and Consumer Services regulations. All officers are licensed under Chapter 493, Florida Statutes. License verification available upon request.",
  copyright: `© ${new Date().getFullYear()} Armed Guard Officers. All rights reserved.`
};
